var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.faClass)?_c('i',{staticClass:"fas group-icon",class:_vm.faClass,attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"material-icons group-icon",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }